import { api } from '@shared/api';
import { getOrCreateDeviceId, hardLogout } from '@shared/auth';

/**
 * Sign out: best-effort backend logout (drops this device's token server-side via the Bearer
 * the `api` client attaches), then purge the local token + caches and bounce to /login.
 */
export async function signOut(): Promise<void> {
  try {
    await api.post('api/v1/auth/logout', { json: { device_id: getOrCreateDeviceId() } });
  } catch {
    // Best effort — the user is signing out locally regardless of the upstream result.
  }
  await hardLogout();
}
